<template>
  <div>
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <template #overlay>
        <div class="text-center">
          <div class="h2 mb-0">
            <b-icon-watch
              font-scale="3"
              animation="cylon"
            />
          </div>
          <h2 class="text-dark">
            Procesando ....
          </h2>
        </div>
      </template>

      <!-- Informacion del Contrato   -->
      <b-row>
        <b-col md="12">
          <b-card>
            <b-card-text>
              <div class="d-flex align-items-center mb-2">
                <div class="avatar-wrapper">
                  <feather-icon
                    icon="UserIcon"
                    class="text-primary"
                    style="font-size: 1.5rem"
                  />
                </div>
                <h5
                  class="mb-0 ml-2 text-dark font-weight-bold"
                >
                  {{ data.nombre }}
                </h5>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>

      <!-- Balance -->
      <b-row>
        <!-- Balance -->
        <b-col
          md="12"
          class="float-right"
        >
          <contract-balance
            :key="componentKey"
            ref="componentebalance"
            :idcontrato="data.idcontrato"
          />
        </b-col>
      </b-row>

      <!-- Actualizar  -->
      <b-row>
        <b-col
          md="4"
          class="float-right mb-1"
          align="left"
        >
          <!-- Botón para exportar a Excel -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="outline-primary"
            class="mr-2 rounded-pill shadow-sm"
            @click="exportToExcel"
          >
            <feather-icon
              icon="DownloadIcon"
              class="mr-1"
            />
            Exportar a Excel
          </b-button>

          <!-- Botón para exportar a PDF -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="outline-danger"
            class="rounded-pill shadow-sm"
            @click="exportToPDF"
          >
            <feather-icon
              icon="FileIcon"
              class="mr-1"
            />
            Exportar a PDF
          </b-button>
        </b-col>

        <b-col md="4" />
        <b-col
          md="4"
          class="float-right mb-1"
          align="right"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="success"
            @click="searchAccountState()"
          >
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
        </b-col>
      </b-row>

      <!-- Tabla -->
      <b-form-group v-if="!show">
        <b-table
          head-variant="dark"
          class="position-relative"
          :items="dataReport"
          responsive
          :fields="fieldscontratocuota"
          primary-key="idcontratocuota"
          show-empty
          empty-text="No matching records found"
          small
          bordered
          sticky-header="500px"
          style="max-height: 700px"
        >
          <template #cell()="dataRow">
            <span class="rowstyle">{{ dataRow.value }}</span>
          </template>

          <template #cell(id)="dataRow">
            <span class="rowstyle">{{ dataRow.index + 1 }}</span>
          </template>

          <template #cell(amountinvoice)="dataRow">
            <span class="rowstyle">
              {{ formatMoneda(dataRow.value) }}
            </span>
          </template>

          <template #cell(taxinvoice)="dataRow">
            <span class="rowstyle">
              {{ formatMoneda(dataRow.value) }}
            </span>
          </template>

          <template #cell(totalinvoice)="dataRow">
            <span class="rowstyle">
              {{ formatMoneda(dataRow.value) }}
            </span>
          </template>

          <template #cell(retencion)="dataRow">
            <span class="rowstyle">
              {{ formatMoneda(dataRow.value) }}
            </span>
          </template>

          <template #cell(balanceinvoice)="dataRow">
            <span class="rowstyle">
              {{ formatMoneda(dataRow.value) }}
            </span>
          </template>

          <template #cell(balancemonthly)="dataRow">
            <span class="rowstyle">
              {{ formatMoneda(dataRow.value) }}
            </span>
          </template>

          <template #cell(quota)="dataRow">
            <div
              v-if="
                dataRow.item.tipocuota == 'O' &&
                  dataRow.item.estado == 'PE' &&
                  dataRow.item.idfactura > 0 &&
                  (dataRow.item.is_deferred == 1 ||
                    dataRow.item.is_deferred == 'true')
              "
              :id="`cuota-icon-${dataRow.item.quota}`"
              class="cursor-pointer text-white mr-1 rounded-circle d-flex align-items-center justify-content-center"
              style="
                                width: 25px;
                                height: 25px;
                                background-color: #0056b3;
                                color: white;
                            "
              title="Cuota"
              @click="openDeferredCollectionModal(dataRow.item)"
            >
              {{ dataRow.item.quota }}
            </div>
          </template>

          <template #cell(collection)="dataRow">
            <span
              class="rowstyle"
              style="position: relative"
            >
              {{ dataRow.item.collection }}
            </span>
          </template>
        </b-table>

        <div class="totals-container mt-3">
          <div class="text-right">
            <strong class="totals-label">Totales:</strong>
            <span class="ml-3 total-item">
              Subtotal:
              {{ formatMoneda(calculateTotal('amountinvoice')) }}
            </span>
            <span class="ml-3 total-item">
              IVA:
              {{ formatMoneda(calculateTotal('taxinvoice')) }}
            </span>
            <span class="ml-3 total-item">
              Total:
              {{ formatMoneda(calculateTotal('totalinvoice')) }}
            </span>
            <span class="ml-3 total-item">
              Retención:
              {{ formatMoneda(calculateTotal('retencion')) }}
            </span>
            <span class="ml-3 total-item">
              Cobros:
              {{ formatMoneda(calculateTotal('collection')) }}
            </span>
            <span class="ml-3 total-item">
              Saldo Factura:
              {{ formatMoneda(calculateTotal('balanceinvoice')) }}
            </span>
            <span class="ml-3 total-item">
              Saldo Prefactura:
              {{ formatMoneda(calculateTotal('balancemonthly')) }}
            </span>
          </div>
        </div>
      </b-form-group>

      <!-- modal Cobros diferidas -->
      <b-modal
        id="modal-deferred-collection"
        :title="`Credito ${data.codigo} - ${data.apenom}`"
        ok-only
        ok-variant="outline-secondary"
        ok-title="Cerrar"
        centered
        size="lg"
        ignore-enforce-focus-selector=".swal2-container, .swal2-center"
        no-close-on-backdrop
      >
        <deferred-collection
          :contrato="dataDeferredCollection"
          @CloseModalDeferredCollection="
            CloseModalDeferredCollection()
          "
        />
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import { avatarText } from '@core/utils/filter'

import ContractBalance from '@/views/contract/ContractBalance.vue'
import DeferredCollection from '@/views/contract/DeferredCollection.vue'
import {
    BButton,
    BCard,
    BCardText,
    BCol,
    BFormGroup,
    BIconWatch,
    BOverlay,
    BRow,
    BTable,
    VBTooltip,
} from 'bootstrap-vue'
import { saveAs } from 'file-saver'
import Ripple from 'vue-ripple-directive'
import * as XLSX from 'xlsx'

export default {
    components: {
        BOverlay,
        BIconWatch,
        BButton,
        BRow,
        BCol,
        BFormGroup,
        BTable,
        DeferredCollection,
        ContractBalance,
        BCard,
        BCardText,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup() {
        return {
            avatarText,
        }
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem('userData')),
            show: true,
            fieldscontratocuota: [
                {
                    key: 'id',
                    label: 'N.-',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                },
                {
                    key: 'tipo',
                    label: 'Transaccion',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                },
                {
                    key: 'fecha',
                    label: 'Fecha',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                },
                {
                    key: 'detalle',
                    label: 'Concepto',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                },
                {
                    key: 'establishment_invoice',
                    label: 'Numero_Factura',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                },
                {
                    key: 'stateinvoice',
                    label: 'Estado',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                },
                {
                    key: 'invoice_date',
                    label: 'Fecha',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                },
                {
                    key: 'amountinvoice',
                    label: 'Subtotal',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    tdClass: 'text-right',
                },
                {
                    key: 'taxinvoice',
                    label: 'Iva',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    tdClass: 'text-right',
                },
                {
                    key: 'totalinvoice',
                    label: 'Total',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    tdClass: 'text-left',
                },
                {
                    key: 'notecredit',
                    label: 'Notas Credito',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    tdClass: 'text-right',
                },
                {
                    key: 'retention',
                    label: 'Retencion',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    tdClass: 'text-right',
                },
                {
                    key: 'collection',
                    label: 'Cobros',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    tdClass: 'text-right',
                },

                {
                    key: 'balanceinvoice',
                    label: 'Saldo_Factura/Nc',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    tdClass: 'text-right',
                },

                {
                    key: 'balancemonthly',
                    label: 'Saldo_Prefacturas/Mens',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    tdClass: 'text-right',
                },

                {
                    key: 'quota',
                    label: 'Cuota',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    tdClass: 'text-right',
                },

                {
                    key: 'debito',
                    label: 'Debito',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
                {
                    key: 'credito',
                    label: 'Credito',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
                {
                    key: 'saldo',
                    label: 'Saldo',
                    sortable: false,
                    thStyle: 'font-size: 10px;',
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
            ],

            asientocontable: { asientocontable: '' },
            idfactura: 0,
            cuotadetvalor: 0,
            cuotadetprod: '',
            cuotadetid: 0,
            cuotaid: 0,
            cuotaidcontrato: 0,
            dataReport: [],
            componentKey: 0,
            estado: '',

            dataDeferredCollection: {},
            contractodetail: [],
        }
    },
    created() {
        if (typeof this.data !== 'undefined') this.show = false
        this.searchAccountState()
    },
    methods: {
        searchAccountState() {
            this.show = true
            this.$http
                .get('/statement-contract-general', {
                    params: {
                        idempresa: this.data.idempresa,
                        idcontrato: this.data.idcontrato,
                    },
                })
                .then((response) => {
                    this.show = false
                    this.dataReport = response.data.data
                    this.forceRerender()
                })
                .catch((error) => {
                    this.show = false
                })
        },

        rowClass(item, type) {
            if (!item || type !== 'row') {
                return
            }

            let clase = ''
            switch (item.tipo) {
                case 'Cuota':
                    clase = 'table-success'
                    // NOTE -  return clase
                    break
                case 'Recibo Ingreso':
                    clase = 'table-primary'
                    // return "table-primary"
                    break
                default:
                    clase = ''
            }

            // eslint-disable-next-line consistent-return
            return clase
        },

        reload() {
            this.searchAccountState()
            this.forceRerender()
        },

        forceRerender() {
            this.componentKey += 1
        },

        openDeferredCollectionModal(item) {
            this.dataDeferredCollection = item

            this.$bvModal.show('modal-deferred-collection')
        },

        CloseModalDeferredCollection() {
            this.$bvModal.hide('modal-deferred-collection')
            this.reload()
        },

        exportToExcel() {
            const rows = this.dataReport
            if (rows.length === 0) {
                this.$swal({
                    title: 'No hay Datos para Exportar',
                    icon: 'warning',
                    timer: 2000,
                })

                return
            }

            const workbook = XLSX.utils.book_new()

            // Crear cabecera personalizada, asegurando que cada fila sea un array con la cantidad de columnas correcta
            const header = [
                ['Empresa:', this.userData.empresa, '', '', ''],
                ['Cliente:', this.data.apenom, '', '', ''],
                ['Identificacion:', this.data.ruc, '', '', ''],
                ['Direccion:', this.data.direccion, '', '', ''],
                ['Telefono:', this.data.telefono, '', '', ''],
                ['Email:', this.data.email, '', '', ''],
                [
                    'Fecha de Corte:',
                    new Date().toLocaleDateString(),
                    '',
                    '',
                    '',
                ],
                [
                    'Balance de Corte:',
                    this.$refs.componentebalance.balancecorte,
                    '',
                    '',
                    '',
                ],
                [
                    'Balance Total:',
                    this.$refs.componentebalance.balance,
                    '',
                    '',
                    '',
                ],
                [], // Fila vacía para separar la cabecera de los datos
            ]

            // Definir los títulos de columna que deseas incluir
            // Definir los títulos de columna que deseas incluir
            const tHeader = [
                [
                    'N.-',
                    'Estado',
                    'Transaccion',
                    'Fecha',
                    'User',
                    'Concepto',
                    'Numero_Factura',
                    'Estado',
                    'Fecha',
                    'Subtotal',
                    'Iva',
                    'Total',
                    'Nota_Credito',
                    'Retencion',
                    'Cobros',
                    'Saldo_Factura/Nc',
                    'Saldo_Prefacturas/Mens',
                    'Cuota',
                ],
            ]
            header.push(...tHeader)

            // Mapear solo los campos seleccionados (en este caso, Codigo, Producto y Stock)
            let i = 0
            const data = rows.map((row) => {
                i += 1

                return [
                    i,
                    row.estado,
                    row.tipo,
                    row.fecha,
                    row.usuario,
                    row.detalle,
                    row.establishment_invoice,
                    row.stateinvoice,
                    row.invoice_date,
                    this.formatMoneda(row.amountinvoice),
                    this.formatMoneda(row.taxinvoice),
                    this.formatMoneda(row.totalinvoice),
                    row.notecredit,
                    row.retencion,
                    this.formatMoneda(row.collection),
                    this.formatMoneda(row.balanceinvoice),
                    this.formatMoneda(row.balancemonthly),
                    row.quota,
                ]
            })

            // Unir el encabezado personalizado con los datos
            const finalData = header.concat(data)

            // Crear una hoja de trabajo y agregar los datos
            const worksheet = XLSX.utils.aoa_to_sheet(finalData)

            // Aplicar estilos a los títulos de las cabeceras
            const boldStyle = { font: { bold: true } }

            // Aplicar negrita a las primeras 5 filas (cabecera)
            for (let rowIndex = 0; rowIndex < 5; rowIndex++) {
                for (
                    let colIndex = 0;
                    colIndex < finalData[rowIndex].length;
                    colIndex++
                ) {
                    const cellAddress = XLSX.utils.encode_cell({
                        r: rowIndex,
                        c: colIndex,
                    })
                    if (!worksheet[cellAddress]) worksheet[cellAddress] = {}
                    worksheet[cellAddress].s = boldStyle
                }
            }

            // Combinar celdas para el nombre de la empresa
            worksheet['!merges'] = [
                { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } }, // Combina celdas B1 a D1
            ]

            // Configurar ancho de las columnas basado en la longitud de los encabezados
            worksheet['!cols'] = [
                { wch: 5 }, // Ancho para la columna N.-
                { wch: 15 }, // Ancho para la columna
                { wch: 30 }, // Ancho para la columna
                { wch: 15 }, // Ancho para la columna
                { wch: 15 }, // Ancho para la columna
                { wch: 15 }, // Ancho para la columna
            ]

            // Agregar la hoja de trabajo al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

            // Guardar el archivo
            const excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array',
            })
            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            })
            saveAs(blob, 'Estado de Cuenta.xlsx')
        },

        exportToPDF() {
            const { idempresa } = this.data
            const { idcontrato } = this.data

            const host = process.env.VUE_APP_API_URL
            const url = `${host}/statement-contract-print?idempresa=${idempresa}&idcontrato=${idcontrato}`

            window.open(url, '_blank')
        },

        roundNumber(value, precision) {
            if (Number.isInteger(precision)) {
                // eslint-disable-next-line no-restricted-properties
                const shift = Math.pow(10, precision)

                return Math.round(value * shift + 0.00000000000001) / shift
            }

            return Math.round(value)
        },

        formatMoneda(value) {
            const val = (value / 1).toFixed(2).replace(',', '.')

            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },

        refresh() {
            this.searchAccountState()
        },

        captureSelectedCheckboxes() {
            const checkboxes = document.querySelectorAll(
                'input[type="checkbox"]'
            )
            const valoresSeleccionados = []

            checkboxes.forEach((checkbox) => {
                // Si está marcado, guardamos su valor
                if (checkbox.checked) {
                    valoresSeleccionados.push(checkbox.value)
                }
            })

            return valoresSeleccionados
        },

        calculateTotal(field) {
            return this.dataReport.reduce((total, item) => {
                const value = parseFloat(item[field]) || 0

                return total + value
            }, 0)
        },
    },
}
</script>

<style>
.rowstyle {
    font-size: 12px;
    color: #2c3e50;
    font-weight: 500;
}

.rowstyleDet {
    font-size: 11px;
    color: #2c3e50;
}

/* Estilos mejorados para la tabla */
.table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
    margin-bottom: 1rem;
    background-color: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.table thead th {
    background: linear-gradient(135deg, #1976d2 0%, #1e88e5 100%);
    color: white;
    font-weight: 600;
    padding: 15px 10px;
    border: none;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: sticky;
    top: 0;
}

.table tbody td {
    padding: 12px 10px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.3s ease;
}

.table tbody tr {
    transition: all 0.3s ease;
}

.table tbody tr:hover {
    background-color: #f8f9fa;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.table tbody tr:nth-child(even) {
    background-color: #fafafa;
}

.table tbody tr:hover td {
    color: #1976d2;
}

/* Estilos para las celdas de números */
.table tbody td.text-right {
    font-family: 'Roboto Mono', monospace;
    font-weight: 500;
}

/* Estilos para el scroll de la tabla */
.table-responsive {
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

/* Estilos para el mensaje de tabla vacía */
.table-empty {
    padding: 30px;
    text-align: center;
    color: #666;
    font-style: italic;
}

.totals-container {
    background-color: #f8f9fa;
    padding: 15px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.totals-label {
    color: #2c3e50;
    font-size: 14px;
}

.total-item {
    color: #1976d2;
    font-weight: 500;
    font-size: 13px;
}
</style>
